import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import './main.less';
import { actions, selectors } from './';

import renderViewsState from '../shared/render-views-state';
import Animate from '../shared/animation';

import Table from './components/table/main';
import FilterForm from './components/filter-form/main';
import Filters from '../shared/filters/main';
import Calendar from '../shared/calendar/main';

import Switch from './components/switch/main';

const Main = renderViewsState(
	props => (
		<Animate>
			<div className="container__content guarant-approve-forecast">
				<div className="container__content-title">
					<div className="container__content-title-position">
						<h1 className="title">{props.intl('Guarant approve forecast')}</h1>
					</div>
				</div>
				<div className="container__content-body">
					<div className="clearfix position-relative">
						<Filters {...props} {...props.filters} />
					</div>
					<div className="display-flex justify-content-flex-end">
						<div>
							<FilterForm
								{...props}
								initialValues={{ is_showed_all: props.showAllEnabled }}
								enableReinitialize={false}
							/>
						</div>
						<Switch {...props} />
						<div className="ui-control-bar__item modify-item---calendar">
							<div className="ui-control-bar__item-position">
								<Calendar
									{...props.calendar}
									onInit={props.calendarInit}
									onToggle={props.calendarToggle}
									onChange={props.calendarChange}
									onApply={props.calendarApply}
									intl={props.intl}
								/>
							</div>
						</div>
						<div>
							<button
								className="ui-btn ui-btn-primary save margin-left-5"
								onClick={props.fetchData}
							>
								{props.intl('Apply')}
							</button>
						</div>
					</div>

					<Table {...props} />
				</div>
			</div>
		</Animate>
	),
	'view'
);

export default connect(
	state => ({
		data: selectors.getData(state),
		dates: selectors.getDates(state),
		table: selectors.getTable(state),
		showAllEnabled: selectors.getShowAllEnabled(state),
		expandedIds: selectors.getExpandedIds(state),
		calendar: selectors.getCalendar(state),
		periodSwitch: selectors.getPeriodSwitch(state),
		progressBar: selectors.getProgressBar(state),
		intl: selectors.getIntl(state),
		filters: selectors.getFilters(state),
		can: selectors.getCan(state),
		error: selectors.getError(state)
	}),
	dispatch => bindActionCreators(actions, dispatch)
)(Main);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/garant-forecast/main.js